import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { LoaderContext } from '../AuthContext/AuthContext';
import couponImage from '../assets/images/new/coupon.png'
import { GetAvailableCouponList } from '../ApiServices/CouponCode/CouponCodeApi'
import { t } from 'i18next';

const CouponModal = ({ show, handleClose, modelRequestData, setIsCouponApplied, setAppliedCoupon, apiParam, setIsWalletApplied }) => {
  const [couponInput, setCouponInput] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [couponList, setCouponList] = useState([])
  const userID = localStorage.getItem("userID");
  const userKeyID = localStorage.getItem("userKeyID");
  const { setLoader } = useContext(LoaderContext);

  const toggleExpand = (id) => {
    setExpandedId(prev => prev === id ? null : id);
  };

  useEffect(() => {
    if (show) {
      GetAvailableCouponListData()
    }

  }, [show])
  const GetAvailableCouponListData = async () => {

    setLoader(true);
    try {
      let response = await GetAvailableCouponList(apiParam); // Replace with actual import/function call
      if (response?.statusCode === 200) {
        setLoader(false);

        const list = response?.responseData?.data
        const updatedList = list?.filter((prev) => prev?.coupenAmount < apiParam?.orderAmount && prev?.coupenAmount !== 0)
        setCouponList(updatedList)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const handleApplyClicked = (coupon) => {
    setIsWalletApplied(false)
    setCouponInput(coupon?.couponCode)
    setAppliedCoupon((prev) => ({ ...prev, couponCode: coupon?.couponCode, couponCode: coupon?.couponCode, isApplied: true, CoupenAmount: coupon?.coupenAmount, couponAmount: coupon?.coupenAmount, couponCodeID: coupon?.couponCodeID, walletAmount: 0 }))
    setIsCouponApplied(true)
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      {/* Header */}
      <Modal.Header
        closeButton
        style={{
          background: "linear-gradient(90deg, #a52444, #f18d9e)",
          color: "#fff",
        }}
      >
        <Modal.Title className="fw-semibold"> {t("Apply Coupon")}</Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body style={{ background: "#fff9f9" }}>
        {couponList?.length > 0 ? (
          <>
            <div style={{  width: "100%", overflowY: "auto" }}>
              <h6 className="mb-3 text-dark fw-semibold">{t("Available Coupons")}</h6>

              {couponList.map((coupon) => (
                <div
                  key={coupon.couponCodeID}
                  className="coupon-card mb-4 p-3 rounded-3 shadow-sm position-relative"
                  style={{
                    border: "1px solid #f0d9dd",
                    borderLeft: "6px solid #a52444",
                    background: "#fff",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(165,36,68,0.2)")
                  }
                  onMouseLeave={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(0,0,0,0.05)")
                  }
                >
                  {/* Background Coupon Image (decorative banner) */}
                  <img
                    src={couponImage}
                    alt="coupon banner"
                    className="position-absolute top-0 end-0 opacity-25"
                    style={{
                      width: "120px",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "0 10px 10px 0",
                      zIndex: 0,
                    }}
                  />

                  <div className="row align-items-center position-relative" style={{ zIndex: 1 }}>
                    {/* Icon - 15% */}
                    <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
                      <img
                        src={couponImage}
                        width={50}
                        height={50}
                        alt="Coupon Icon"
                        className="rounded-circle border"
                        style={{
                          borderColor: "#a52444",
                          padding: "4px",
                          backgroundColor: "#fff",
                        }}
                      />
                    </div>

                    {/* Code + Description - 65% */}
                    <div className="col-12 col-md-7">
                      <div
                        className="fw-bold text-dark px-3 py-1 mb-2"
                        style={{
                          display: "inline-block",
                          border: "2px dashed #a52444",
                          borderRadius: "6px",
                          fontSize: "14px",
                          background: "#fff0f2",
                        }}
                      >
                        {coupon.couponCode}
                      </div>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "13.5px", lineHeight: "1.5" }}
                      >
                        {coupon.description}
                      </p>
                    </div>

                    {/* Apply Button - 20% */}
                    <div className="col-12 col-md-3 mt-3 mt-md-0 d-flex justify-content-md-end">
                      <button
                        className="btn btn-sm w-100 text-white"
                        style={{
                          background:
                            "linear-gradient(90deg, #a52444, #f18d9e)",
                          fontWeight: "600",
                          fontSize: "13px",
                          borderRadius: "20px",
                          letterSpacing: "0.5px",
                          boxShadow: "0 2px 6px rgba(165,36,68,0.3)",
                        }}
                        onClick={() => handleApplyClicked(coupon)}
                      >
                        {t("APPLY")}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-5">
            <img
              src={couponImage}
              alt="No Coupons"
              width={100}
              className="mb-3 opacity-75"
            />
            <h5 className="text-dark fw-semibold">{t("No Coupons Available")}</h5>
          </div>
        )}
      </Modal.Body>
    </Modal>


  );
};

export default CouponModal;
